/**
 * Content Constants
 * this file contains ar/en content that is static and not exist in lokalise
 * Note: should be very minimal and it is better to be empty :D
 *
 * Naming Convention: SCREAMING_SNAKE_CASE
 * i.e. CONTENT_CONSTANT
 */

// TODO: use design system icons
import AirplaneIcon from "@/assets/images/airplaneTop.svg";
import BusIcon from "@/assets/images/bus.svg";
import TrainIcon from "@/assets/images/train.svg";
import { APPEARANCES } from "@tajawal/ct-web-design-system/dist/components/Tag";
import { STOP_FILTER_CODE_MAP } from "@tajawal/web-flights-sdk/lib/constants/filters.constants";

export const EXAMPLE_CONTENT = {
  en: "example",
  ar: "مثال",
};

export const BAGGAGE_TEXT_TYPES = {
  V1: "V1",
  V2: "V2",
};

export const IS_FROM_FARE_CALENDAR = "isFromFareCalendar";

export const FARE_RULES_ICONS = {
  REISSUE_WITHOUT_FEES: "checkMarkIcon",
  REISSUE_WITH_FEES: "feesIcon",
  NO_REISSUE: "cancelIcon",
  REFUNDABLE_WITHOUT_FEES: "checkMarkIcon",
  REFUNDABLE_WITHOUT_FEES_CREDIT: "infoIcon",
  REFUNDABLE_WITH_FEES: "feesIcon",
  REFUNDABLE_WITH_FEES_CREDIT: "infoIcon",
  NO_REFUND: "cancelIcon",
  NO_REFUND_CREDIT: "cancelIcon",
  INFO_UNAVAILABLE_GDS: "warningInfoIcon",
  INFO_UNAVAILABLE: "notAvailableIcon",
};
export const INSURANCE_DOMESTIC_BENEFITS = [
  "PersonalAccident",
  "TripCancellation",
  "MissedDeparture",
  "TripDelay",
  "BaggageDelay",
  "PersonalPossessions",
] as const;
export const INSURANCE_INTERNATIONAL_BENEFITS = [
  "PersonalAccident",
  "EmergencyMedicalExpense",
  "RepatriationOfRemains",
  "TripCancellation",
  "MissedDeparture",
  "TripDelay",
  "BaggageDelay",
  "PersonalPossessions",
  "LossOfTravelDocument",
  "PersonalLiability",
] as const;

export const TRANSLATION_SEPARATOR = ";";

export const BAGGAGE_OPTION_ICONS = {
  INCLUDED: "BaggageIncluded",
  AVAILABLE: "BaggagePlus",
  ADDED: "BaggageAdded",
  NOT_INCLUDED: "BaggageNotIncluded",
};

export const AIRCRAFT_ICONS_SRC = {
  AIRPLANE: AirplaneIcon.src,
  BUS: BusIcon.src,
  TRAIN: TrainIcon.src,
};

export const FLIGHT_CARD_TAGS: {
  [key: string]: {
    appearance: (typeof APPEARANCES)[keyof typeof APPEARANCES];
    text: string;
  };
} = {
  isRecommended: {
    appearance: "forest",
    text: "FlightCard.TopPick_BestValue",
  },
  isCheapest: {
    appearance: "aqua",
    text: "FlightCard.TopPick_Cheapest",
  },
  isShortest: {
    appearance: "aqua",
    text: "FlightCard.TopPick_Shortest",
  },
  isTopPick: {
    appearance: "grey",
    text: "SearchResults.TopPicks_Title",
  },
};

export const STOP_FILTER_OPTION_LABEL = {
  [STOP_FILTER_CODE_MAP.DIRECT_ONLY]: "Filters.Stops_Direct",
  [STOP_FILTER_CODE_MAP.ONE_STOP_PLUS]: "Filters.Stops_OneStop",
  [STOP_FILTER_CODE_MAP.TWO_STOPS_PLUS]: "Filters.Stops_TwoStop",
};
